
import Rates from "@/components/rates";
import Foot from "@/layouts/foot";
import Branchdetailplaceholder from "@/components/placeholders/branchdetailplaceholder";
import Productlistcard from "~/components/products/productlistcard";
import productModel from "@/models/products";
import Productbar from "@/components/search/productbar";
import products from "@/models/products";
import Productgridplaceholder from "@/components/placeholders/productgridplaceholder";
import Productlistplaceholder from "@/components/placeholders/productlistplaceholder";
import Productlistgrid from "@/components/products/productlistgrid";
import Productbranchbar from "@/components/search/productbranchbar";

export default {
  name: "index",
  components: {
    Productbranchbar,
    Productlistgrid,
    Productlistplaceholder,
    Productgridplaceholder, Productbar, Productlistcard, Branchdetailplaceholder, Foot, Rates},
  data() {
    return {
      branch: {},
      feedbacks: [],
      products: [],
      tab: 2,
      placeholder: true,
      listType: 2,
      total: '',
      sort: '',
      productNull: 0,
      execute: false,
      perPage: 1,
      selectedFilters: [],
      cities: [],
      metaTitle: "",
    }
  },

  head() {
    return {
      title: this.metaTitle + " " + this.$nuxt.$helpers.upperCaseEach(this.branch.city)  + "Τιμές ελαστικών",
      meta: [
        { hid: 'description', name: 'description', content: this.branch.name + " "+ "ürünlerini tirelet ile satın alabilir"+" "+this.branch.city+" "+this.branch.district+" "+"adresindeki montaj noktasında taktırabilirsiniz." },
        { hid: 'keywords', name: 'keywords', content:"servislet"+ ","+this.branch.name+ ","+this.branch.city+ ","+ this.branch.district+ ","+ "lastik servisi,montaj noktası,ürünleri" }
      ],
    }
  },
  computed: {
    totalPage: {
      get() {
        return this.$store.state.products.totalPage || 0
      },
      set(value) {
        this.$store.commit('products/setTotalPage', value)
      }
    },
    city: {
      get() {
        return this.$store.state.city.slug
      },
      set(value) {
        this.$cookies.set("city", value)
        this.$cookies.set('city', value);
        this.$store.commit('city/setCitySlug', value)
      },
    }
  },
  mounted() {
    if (this.$route.query.tab === 'comment') {
      this.tab = 3
    }
    this.$store.commit('city/setCitySlug', this.city)
    var _this = this
    setTimeout(function () {
      _this.refresh()
    },500)
  },
  methods: {
    refresh() {
      driverreviews.isRefreshing= false
      driverreviews.refreshWidgets();
    },
    url(product) {
      this.$store.state.city.slug = this.branch.city_slug
      this.$router.push(this.localePath({name: 'product', params: {product: product.slug}, query: {store: this.$nuxt.$helpers.slugify(this.branch.name)}}))
    },
    infiniteScroll($state) {
      if (!this.$route.query.page) {
        this.$route.query.page  = 1
      }
      if (!this.execute) {
        this.execute = !this.execute
        if (this.products.length > 0) {
          if (this.totalPage > this.$route.query.page) {
            setTimeout(() => {
              var nextPage = (parseInt(this.$route.query.page) + 1)
              this.$route.query.page = nextPage
              var url = new URL(window.location.href);
              url.searchParams.set('page', (this.$route.query.page))
              window.history.pushState({}, '', url);
              this.$fetch().then(() => {
                $state.loaded();
                this.execute = false
              })
            },600)
          } else {
            $state.complete();
          }
        }
      }
    },
    changeListType(type) {
      this.listType = type
    },
    sortChange() {
      this.$route.query.sort_column = this.sort.split(',')[0]
      this.$route.query.sort_direction = this.sort.split(',')[1]
      var query = {}
      if (this.$route.query.city) {
        query.city = this.$route.query.city
      }
      if (this.$route.query.season) {
        query.season = this.$route.query.season
      }
      if (this.$route.query.width) {
        query.width = this.$route.query.width
      }
      if (this.$route.query.height) {
        query.height = this.$route.query.height
      }
      if (this.$route.query.radius) {
        query.radius = this.$route.query.radius
      }
      if (this.$route.query.sort_column) {
        query.sort_column = this.sort.split(',')[0]
      }
      if (this.$route.query.sort_direction) {
        query.sort_direction = this.sort.split(',')[1]
      }
      this.$router.push(this.localePath({
        name: 'branch',
        params: this.$route.params,
        query: query
      }))
    },
  },
  fetchKey: 'branch-sidebar',
  watch: {
    '$route.query': '$fetch',
    products() {
      var _this = this
      if (this.products.length > 0) {
        setTimeout(function () {
          _this.refresh()
        },100)
      }
    }
  },
  async fetch() {
    try {
      if (process.client) {
        this.metaTitle = document.title.replace(' | Tirelet', '')
      }
      this.execute = false
      this.productNull = 0
      var branch = await this.$http.$get(`/home-page/branches/by-slug/${this.$route.params.branch}`)
      this.branch = branch.data.branch
      if (this.branch.city) {
        this.city = this.branch.city_slug
      }
      if (!this.$route.query.page) {
        this.$route.query.page = 1
      }
      if (this.$route.query.season) {
        var url = `/tire/products/opensearch?brand_id=${this.branch.branchGroup.id}&branch_slug=${this.$route.params.branch}&limit=24&page=${this.$route.query.page}&branch_id=${this.branch.id}&width=${this.$route.query.width || ''}&height=${this.$route.query.height || ''}&radius=${this.$route.query.radius || ''}&seasons[0]=${this.$route.query.season || ''}`
      } else {
        var url = `/tire/products/opensearch?brand_id=${this.branch.branchGroup.id}&branch_slug=${this.$route.params.branch}&limit=24&page=${this.$route.query.page}&branch_id=${this.branch.id}&width=${this.$route.query.width || ''}&height=${this.$route.query.height || ''}&radius=${this.$route.query.radius || ''}`
      }

      if (this.$route.query.brand) {
        url += `&brand_slug=${this.$route.query.brand}`
      } else {
        url += `&brand_slug=${this.branch.brands[0].slug}`
      }

      if (this.$route.query.sort_column && this.$route.query.sort_direction) {
        var url = url + `&sort_column=${this.$route.query.sort_column}&sort_direction=${this.$route.query.sort_direction}`
      }

      if (this.$route.query.search) {
        var url = url + `&search_text=${this.$route.query.search}`
      }

      if (this.$route.query.category) {
        var url = url + `&category_slug=${this.$route.query.category}`
      }

      if (this.$route.query.min) {
        var url = url + `&min_price=${this.$route.query.min}`
      }

      if (this.$route.query.max) {
        var url = url + `&max_price=${this.$route.query.max}`
      }

      if (this.$route.query.run_flat) {
        var url = url + `&run_flat=${this.$route.query.run_flat}`
      }

      if (this.$route.query.load) {
        var url = url + `&load_index=${this.$route.query.load}`
      }

      if (this.$route.query.speed) {
        var url = url + `&speed=${this.$route.query.speed}`
      }

      if (this.$route.query.car) {
        var url = url + `&car_types[0]=${this.$route.query.car}`
      }

      if (this.$route.query.page == '1') {
        this.products = []
        var response = await this.$http.$get(url).catch(error => {
          this.$router.push(this.localePath('miscellaneous-error'))
        })
        if (response.code === 1000) {
          this.perPage = response.data.pagination.per_page
          this.total = response.data.pagination.total
          this.totalPage = response.data.pagination.total_page
          this.selectedFilters = response.data.selectedFilters
          this.products = productModel.collection(response.data.items)
        }

      } else {
        var response = await this.$http.$get(url).catch(error => {
          this.$router.push(this.localePath('miscellaneous-error'))
        })
        if (response.code === 1000) {
          this.perPage = response.data.pagination.per_page
          this.total = response.data.pagination.total
          this.totalPage = response.data.pagination.total_page
          this.selectedFilters = response.data.selectedFilters
          response.data.items.forEach((product) => {
            this.products.push(productModel.get(product))
          })
        }
      }

      if (this.products.length === 0) {
        this.productNull = 1
      }
      var feedbacks = await this.$http.$get(`/branch/feedback/${this.$route.params.branch}`)
      this.feedbacks = feedbacks.data.feedback

      this.placeholder = false

      this.metaTitle = (this.branch.meta_title ||this.branch.name)

    }catch (e) {
      this.$router.push(this.localePath('miscellaneous-error'))
    }
  },
}
